import { render, staticRenderFns } from "./CreateService.vue?vue&type=template&id=b2625640&scoped=true"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"
import style0 from "./CreateService.vue?vue&type=style&index=0&id=b2625640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2625640",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
